import React from 'react';
import { CheckCircle, MinusCircle, XCircle } from 'phosphor-react';

const statuses = {
    done: 'Complete',
    created: 'Created',
    failed: 'Failed',
    active: 'Active',
    pending: 'Pending',
    cancelled: 'Cancelled',
}

export const RowStatus = ({ status }) => {
    const IconStyle = { marginLeft: '0.5rem' };

    let Icon;
    let color;

    switch (status) {
        case 'done':
            Icon = <CheckCircle size={17} style={IconStyle} />;
            color = '#64b450';
            break;
        case 'active':
        case 'created':
        case 'pending':
            Icon = <MinusCircle size={17} style={IconStyle} />;
            color = '#0099CC';
            break;
        default:
            Icon = <XCircle size={17} style={IconStyle} />;
            color = '#ff0033';
            break;
    }

    return (
        <div style={{
            display: 'inline-flex',
            color: color,
            fontWeight: 'bold',
            alignSelf: 'flex-start',
            padding: '1rem 0',
        }}>
            {statuses[status] ?? status}

            {Icon}
        </div>
    )
}
